import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { AnalyticsEcommerceHelpersOysho } from '../helpers/brand-analytics-ecommerce.helpers.oy';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';

export const BundleEvents: AnalyticsBrandSettings = {

  fichaBundleCheckoutAnadirBundleCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'checkout', 'ficha_bundle', 'anadir_bundle_cesta', product?.fullReference
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  fichaBundleCheckoutAnadirProductoCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];

    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }
    const label = `${componentData?.partnumber}-${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'checkout', 'ficha_bundle', 'anadir_producto_cesta', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['16', '17', '198', '20', '48', '58', '65', '70', '71', '98'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  fichaBundleCheckoutAnadirProductoCrossCesta(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true, size: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'checkout', 'ficha_bundle', 'anadir_producto_cross_cesta', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['139', '16', '17', '198', '20', '48', '58', '65', '70', '71', '98'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceAdd(componentData, context);
    return settingsGTM;
  },

  fichaBundleWishlistAnadirProductoCrossWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${product?.id}-${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'ficha_bundle', 'anadir_producto_cross_wishlist', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['16', '17', '198', '20', '65', '71'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleWishlistAnadirProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${product?.id}-${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'ficha_bundle', 'anadir_producto_wishlist', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['16', '17', '198', '20', '65', '71'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleWishlistEliminarProductoCrossWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${product?.id}-${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'ficha_bundle', 'eliminar_producto_cross_wishlist', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleWishlistEliminarProductoWishlist(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${product?.id}-${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'wishlist', 'ficha_bundle', 'eliminar_producto_wishlist', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['16', '17', '198', '20', '65', '71'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoSeleccionarColor(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${componentData?.partnumber}-${partnumber}-color_${product?.color}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'seleccionar_color', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '48', '65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoSeleccionarColorProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-color_${product?.color}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'seleccionar_color_producto_cross', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '48', '65', '139'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoSeleccionarTalla(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${componentData?.partnumber}-${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'seleccionar_talla', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '58', '65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoSeleccionarLargo(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${componentData?.partnumber}-${partnumber}-largo_${product?.sizeLong}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'seleccionar_largo', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '14', '65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoSeleccionarTallaProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'seleccionar_talla_producto_cross', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '58', '65', '139'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoSeleccionarLargoProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-largo_${product?.sizeLong}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'seleccionar_largo_producto_cross', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '14', '65', '139'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoVerComingSoon(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${partnumber}-talla_${product?.sizeCode}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'ver_coming_soon', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '48', '58', '65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleDisponibilidadEnTiendaVerDisponibilidadTienda(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${product?.id}-${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'disponibilidad_en_tienda', 'ficha_bundle', 'ver_disponibilidad_tienda', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleAyudaVerGuiaTallas(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_bundle', 'ver_guia_tallas');
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleAyudaVerGuiaTallasTrueFit(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'ayuda', 'ficha_bundle', 'ver_guia_tallas_true_fit');
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['20', '65'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoVerVistaRapidaProducto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }
    const label = `${product?.id}-${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'ver_vista_rapida_producto', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '20', '46', '47', '65', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  fichaBundleCatalogoVerVistaRapidaProductoCross(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'ver_vista_rapida_producto_cross', partnumber
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '139', '20', '47', '65', '70', '98', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

  fichaBundleCatalogoVerZoom(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'ver_zoom', componentData?.imagePosition
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '47'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoVerFotoAuxiliar(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData } = data;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'ver_foto_auxiliar', componentData?.imagePosition
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '47'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  fichaBundleCatalogoVerProducto(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers, componentData, context } = data;
    const product = componentData.products?.[0];
    let partnumber;
    if (isDefined(product)) {
      partnumber = AnalyticsHelpersOysho.getPartnumber(product, { color: true });
    }

    const label = `${componentData?.partnumber}-${partnumber}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'catalogo', 'ficha_bundle', 'ver_producto', label
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);

    const dimensions: string [] = ['100', '101', '117', '139', '20', '46', '47', '70', '98', '99'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    settingsGTM.ecommerce = AnalyticsEcommerceHelpersOysho.getEcommerceClick(componentData, context);
    return settingsGTM;
  },

};
